import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

/// This formats a datetime in local with a hover over to show the UTC time
class LocalDateTime extends React.PureComponent {
    render() {
        const {
            epochms,
        } = this.props;
        const utc = DateTime.fromMillis(Number(epochms), { zone: 'UTC' });
        const local = utc.setZone('local');

        return (
            <p
                className="tooltip"
                data-tooltip={utc.toFormat('ffZ')}
            >
                {local.toFormat('ffZ')}
            </p>
        );
    }
}

LocalDateTime.propTypes = {
    epochms: PropTypes.number.isRequired,
};

export default LocalDateTime;
